import React, { createContext, useContext, useState, useEffect } from 'react';
import pb from '../lib/pocketbase';

const SocieteContext = createContext({
    categories: [],
    sections: [],
    hero: null,
    loading: true,
    refresh: () => { }
});

export const useSocieteData = () => useContext(SocieteContext);

export const SocieteProvider = ({ children }) => {
    const [categories, setCategories] = useState([]);
    const [sections, setSections] = useState([]);
    const [hero, setHero] = useState(null);
    const [loading, setLoading] = useState(true);

    const loadData = async () => {
        try {
            const [cats, sects, heroes] = await Promise.all([
                pb.collection('societe_categories').getFullList({ sort: 'order' }).catch(() => []),
                pb.collection('societe_sections').getFullList({ sort: 'order' }).catch(() => []),
                pb.collection('societe_hero').getFullList({ sort: '-created', max: 1 }).catch(() => [])
            ]);
            setCategories(cats);
            setSections(sects);
            setHero(heroes.length > 0 ? {
                title: heroes[0].title || 'Société',
                subtitle: heroes[0].subtitle || '',
                buttons: heroes[0].buttons || [],
                slider_title: heroes[0].slider_title,
                slider_subtitle: heroes[0].slider_subtitle
            } : null);
        } catch (err) {
            console.error("Error loading societe data:", err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadData();
    }, []);

    return (
        <SocieteContext.Provider value={{ categories, sections, hero, loading, refresh: loadData }}>
            {children}
        </SocieteContext.Provider>
    );
};
